import { MessageCircle, Mail, MapPin, ExternalLink } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function getImageUrl(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
}

export default function Footer({ contact, general }) {
  const phone = (contact.whatsapp || general.whatsapp || "657871824").replace(/\D/g, "");
  const whatsappUrl = `https://wa.me/34${phone}`;
  const logoUrl = getImageUrl(general.logo_url);

  return (
    <footer className="bg-[#0F172A] text-white py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 mb-14">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              {logoUrl && (
                <img src={logoUrl} alt="Logo" className="w-14 h-14 object-contain rounded-full bg-white p-1" />
              )}
              <div>
                <div className="font-['Montserrat'] font-bold text-lg text-white">Campus Verano Activo</div>
                <div className="text-[#94A3B8] text-sm font-['Montserrat']">La Estanca 2026</div>
              </div>
            </div>
            <p className="text-[#94A3B8] font-['Montserrat'] text-sm leading-relaxed">
              Un campamento de verano lleno de actividades, naturaleza y aventura para niños y jóvenes.
            </p>
            <p className="text-[#475569] font-['Montserrat'] text-xs mt-3">
              Organiza: {general.organization || "Asociación MuéveTe"}
            </p>
            {general.director && (
              <p className="text-[#475569] font-['Montserrat'] text-xs mt-1">
                Director: {general.director}
              </p>
            )}
          </div>

          {/* Links */}
          <div>
            <h3 className="font-['Montserrat'] font-bold text-lg mb-4 text-[#F5C518]">Navegación</h3>
            <ul className="space-y-2">
              {["Actividades", "Horarios", "Precios", "Inscripción"].map(item => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="text-[#94A3B8] font-['Montserrat'] text-sm hover:text-white transition-colors flex items-center gap-2"
                  >
                    <div className="w-1 h-1 rounded-full bg-[#0072A4]" />
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-['Montserrat'] font-bold text-lg mb-4 text-[#F5C518]">Contacto</h3>
            <div className="space-y-3">
              {contact.whatsapp && (
                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="flex items-center gap-3 text-[#94A3B8] hover:text-[#3CB44B] transition-colors group"
                >
                  <div className="w-8 h-8 rounded-full bg-[#3CB44B]/20 flex items-center justify-center group-hover:bg-[#3CB44B]/30 transition-colors">
                    <MessageCircle size={16} color="#3CB44B" />
                  </div>
                  <span className="font-['Montserrat'] text-sm">{contact.whatsapp.replace(/(\d{3})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5")}</span>
                </a>
              )}
              {contact.email && (
                <a
                  href={`mailto:${contact.email}`}
                  data-testid="footer-email-link"
                  className="flex items-center gap-3 text-[#94A3B8] hover:text-[#0072A4] transition-colors group"
                >
                  <div className="w-8 h-8 rounded-full bg-[#0072A4]/20 flex items-center justify-center group-hover:bg-[#0072A4]/30 transition-colors">
                    <Mail size={16} color="#0072A4" />
                  </div>
                  <span className="font-['Montserrat'] text-sm break-all">{contact.email}</span>
                </a>
              )}
              {contact.location && (
                <div className="flex items-center gap-3 text-[#94A3B8]">
                  <div className="w-8 h-8 rounded-full bg-[#F58220]/20 flex items-center justify-center">
                    <MapPin size={16} color="#F58220" />
                  </div>
                  <span className="font-['Montserrat'] text-sm">{contact.location}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-[#1E293B] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#475569] font-['Montserrat'] text-sm">
            © 2026 Campus Verano Activo La Estanca — {general.organization || "Asociación MuéveTe"}
          </p>
          <a
            href="/admin"
            className="flex items-center gap-1 text-[#334155] hover:text-[#475569] transition-colors text-xs font-['Montserrat']"
            data-testid="admin-link"
          >
            <ExternalLink size={12} />
            Panel Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
